import posthog from 'posthog-js'

const KEY = import.meta.env.VITE_POSTHOG_KEY as string | undefined
const HOST = (import.meta.env.VITE_POSTHOG_HOST as string | undefined) ?? 'https://us.i.posthog.com'

let ready = false

/**
 * Initializes PostHog in cookieless mode. No-ops when `VITE_POSTHOG_KEY` is unset,
 * so local dev and un-keyed builds run with analytics fully disabled and the demo
 * behaves identically. Safe to call more than once.
 */
export const initAnalytics = (): void => {
  if (ready || !KEY || typeof window === 'undefined') return
  posthog.init(KEY, {
    api_host: HOST,
    persistence: 'memory', // cookieless: no cookies, no localStorage
    autocapture: false, // funnel is driven by the explicit events below
    capture_pageview: true,
    capture_pageleave: true,
    capture_performance: true, // Core Web Vitals (LCP/CLS/INP) — replaces CF Web Analytics baseline
    disable_session_recording: true, // enable in the project + flip this for replay
  })
  ready = true
}

/**
 * Records a funnel/interaction event. No-ops until `initAnalytics()` has run with a key.
 *
 * @param event - Event name, e.g. `'step_viewed'`
 * @param props - Optional event properties, e.g. `{ step: 'capture' }`
 */
export const track = (event: string, props?: Record<string, unknown>): void => {
  if (!ready) return
  posthog.capture(event, props)
}
